import { Directive, ElementRef, inject, input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appAlternatingRow]',
  standalone: true,
})
export class AlternatingRowDirective implements OnInit {
  private readonly el = inject(ElementRef);
  private readonly renderer = inject(Renderer2);
  public index = input.required<number>({ alias: 'appAlternatingRow' });

  public ngOnInit(): void {
    if (this.index() % 2 === 0) {
      this.renderer.addClass(this.el.nativeElement, 'bg-light');
    } else {
      this.renderer.addClass(this.el.nativeElement, 'bg-gray');
    }
  }
}
